import { Button } from "@/components/button";
import { AutoImageSwiper } from "@/components/swiper";
import { THEME_CHOICE } from "@/store/themeCustom";
import { memo } from "react";
import { THEMES_SWIPER } from "./constants";
import { useTracking } from "@/hooks/useTracking";

interface RenderChoiceThemeProps {
  theme: THEME_CHOICE
  themeSelect: THEME_CHOICE
  setTheme: (theme: THEME_CHOICE) => void
}

export const RenderChoiceTheme = memo(({ theme, themeSelect, setTheme }: RenderChoiceThemeProps) => {
  const { sendEvent } = useTracking();

  const handleSetTheme = () => {
    setTheme(theme)

    sendEvent("button_clicked", {
      event_category: "choice_theme",
      event_label: `Tema ${theme}`,
      event_action: "click",
      value: 1,
    });
  };

  return (
    <div className="next_level__wrapper__choice_theme__theme">
      <AutoImageSwiper cards={THEMES_SWIPER[theme]} />

      <Button
        theme={theme === themeSelect ? 'primary' : 'tertiary'}
        onClick={handleSetTheme}
        size="small"
      >
        {theme === themeSelect ? 'Tema selecionado' : 'Selecionar tema'}
      </Button>
    </div>
  );
});
